import React from 'react';
import { XCircle } from 'lucide-react'; // Optional icon from lucide-react

const Voltfailed = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-red-50 p-4">
      <XCircle className="text-red-600 w-16 h-16 mb-4" />
      <h1 className="text-2xl font-bold text-red-700 mb-2">Payment Failed!</h1>
      <p className="text-gray-600 mb-6">
        Oops! Something went wrong during your transaction. Please try again.
      </p>
      <button onClick={() => window.location.href = '/'}>Try Again</button>
    </div>
  );
};

export default Voltfailed;
